export const getSubProductLinkFn = ({
  productCode,
  subProductCode,
  programId,
  dashboardId,
}: {
  productCode: string
  subProductCode: string
  programId?: string
  dashboardId?: string
}) => {
  return `/${productCode}/${subProductCode}${programId ? `/${programId}` : ''}${dashboardId ? `?dashboardId=${dashboardId}` : ''}`
}
